// File: src/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

// If using Create React App, ensure you have:
//   REACT_APP_SUPABASE_URL
//   REACT_APP_SUPABASE_ANON_KEY
// in your .env.

// Use your .env naming convention
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

console.log('Supabase Config:', { url: supabaseUrl, hasKey: !!supabaseAnonKey });

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      // a custom localStorage key to avoid multiple clients
      storageKey: 'my-custom-auth-storage-react',
      persistSession: true,
      detectSessionInUrl: true,
      // Add debug logs to help troubleshooting auth issues
      debug: true, 
      // Ensure we can handle various URL formats during password reset
      flowType: 'pkce'
    },
    global: {
      headers: {
        'apikey': supabaseAnonKey,
      }
    }
  }
)

// Log auth state changes to help with debugging
supabase.auth.onAuthStateChange((event, session) => {
  console.log(`Global Auth Event: ${event}`, { hasSession: !!session })
})
